module.exports = __webpack_public_path__ + "static/media/nextjs.81e37415.svg";